import React from "react";
import LaptopWindowsRoundedIcon from "@material-ui/icons/LaptopWindowsRounded";
import mfrid from "./images/mfrid.PNG";
import calculator from "./images/calculator.png";
import portfolio from "./images/portfolio-two.png";
import amazonClone from "./images/amazonClone.png";
import instagram from './images/instagram.png'
import githubuser from './images/githubuser.PNG'
import netflix from './images/netflix.PNG'

import "./Project.css";

function Project() {
  return (
    <div className="project">
      <div
        className="project__heading skills__header"
        style={{ marginBottom: "20px" }}
      >
        <LaptopWindowsRoundedIcon className="skills__icon" />
        <h1>Projects</h1>
      </div>
      <div className="project__wrapper">
        <a
          href="https://mfird-staging.netlify.app/#"
          data-aos="fade-right"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="project__holder">
            <img src={mfrid} alt="avatar" className="image" />
            <div className="overlay">
              <div className="text">
                <h2 style={{ marginBottom: "10px" }}>MFIRD</h2>
                <p>
                  An organisation to provide a common platform for professionals
                  across industries.
                </p>
                <h5 style={{ marginTop: "10px" }}>
                  Technology used: HTML, CSS, JS
                </h5>
              </div>
            </div>
          </div>
        </a>

        {/* 2 */}

        <a
          href="https://instagram-clone07.netlify.com"
          data-aos="fade-left"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="project__holder">
            <img src={instagram} alt="avatar" className="image" />
            <div className="overlay">
              <div className="text">
                <h2 style={{ marginBottom: "10px" }}>Instagram clone</h2>
                <p>
                  A simple instagram clone with authentication, post image and
                  comment functionality .
                </p>
                <h5 style={{ marginTop: "10px" }}>
                  Technology used: React.js, Material ui
                </h5>
              </div>
            </div>
          </div>
        </a>

        {/* 3 */}

        <a
          href="https://githubuser-search07.netlify.com"
          data-aos="fade-right"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="project__holder">
            <img src={githubuser} alt="avatar" className="image" />
            <div className="overlay">
              <div className="text">
                <h2 style={{ marginBottom: "10px" }}>Github User</h2>
                <p>
                  Github user project where you can see your number of repo's,
                  followers and following.
                </p>
                <h5 style={{ marginTop: "10px" }}>
                  Technology used: React.js, Piechart
                </h5>
              </div>
            </div>
          </div>
        </a>

        {/* 4 */}

        <a
          href="https://netflix-clone07.netlify.com"
          data-aos="fade-right"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="project__holder">
            <img src={netflix} alt="avatar" className="image" />
            <div className="overlay">
              <div className="text">
                <h2 style={{ marginBottom: "10px" }}>Netflix Clone</h2>
                <p>
                  Netflix clone
                </p>
                <h5 style={{ marginTop: "10px" }}>
                  Technology used: React.js, Imdb api
                </h5>
              </div>
            </div>
          </div>
        </a>

        {/* 5 */}

        <a
          href="https://simple-calci.netlify.app/"
          data-aos="fade-left"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="project__holder">
            <img src={calculator} alt="avatar" className="image" />
            <div className="overlay">
              <div className="text">
                <h2 style={{ marginBottom: "10px" }}>CALCULATOR</h2>
                <p>A simple calculator which perform arithmatic operations.</p>
                <h5 style={{ marginTop: "10px" }}>
                  Technology used: HTML, CSS, JQUERY
                </h5>
              </div>
            </div>
          </div>
        </a>
        <a
          href="https://yahiyyakhan.netlify.app/"
          data-aos="fade-right"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="project__holder">
            <img src={portfolio} alt="avatar" className="image" />
            <div className="overlay">
              <div className="text">
                <h2 style={{ marginBottom: "10px" }}>PORTFOLIO</h2>
                <p>
                  A static portfolio which does not perform any user
                  interaction. Builded for myself in the early stage of
                  learning.
                </p>
                <h5 style={{ marginTop: "10px" }}>
                  Technology used: HTML, CSS, JS
                </h5>
              </div>
            </div>
          </div>
        </a>
        <a
          href="https://clone-5fa64.web.app/"
          data-aos="fade-left"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="project__holder">
            <img src={amazonClone} alt="avatar" className="image" />
            <div className="overlay">
              <div className="text">
                <h2 style={{ marginBottom: "10px" }}>AMAZON CLONE</h2>
                <p>Amazon Clone build with ReactJs</p>
                <h5 style={{ marginTop: "10px" }}>
                  Technology used: REACT.JS, MATERIAL UI
                </h5>
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>
  );
}

export default Project;
